export const isIFrameMode = () => {
  return window.self !== window.top;
}
